<mat-card>
    <mat-card-header style="flex-direction: row; justify-content: space-between; align-items: baseline;">
        <mat-card-title>
            <h2>{{ title() }}</h2>
        </mat-card-title>
        <button mat-raised-button
                color="accent"
                [matMenuTriggerFor]="addNewCardMenu" i18n>Add new widget</button>
        <mat-menu #addNewCardMenu="matMenu">
            @for (type of boardCardRegistry.typesSortedByTitle; track type) {
            <button mat-menu-item (click)="onAddCard(type)">{{ type.title }}</button>
            }
        </mat-menu>
    </mat-card-header>
    <mat-card-content>
        <div cdkDropListGroup class="de-column-list">
            @for (column of board.columns; track column.id) {
            <div class="de-column"
                cdkDropList
                [cdkDropListData]="column.cards"
                (cdkDropListDropped)="onDrop($event)">
                @for (card of column.cards; track card.id) {
                <eas-board-layout-editor-card [card]="card"
                                                cdkDrag
                                                (deleteCard)="onRemoveCard($event)"
                                                (editCard)="onChangeCardSettings($event)"/>
                } @empty {
                    <div class="de-column-empty">
                        @if (board.isEmpty) {
                            This layout has no cards, add widgets and drag & drop them to create your layout.
                        } @else {
                            This column is empty, you drag & drop widgets from other columns to create your layout.
                        }
                    </div>
                }
            </div>
            }
        </div>
    </mat-card-content>
</mat-card>